{
  "title": "Endre hovedsortiment",
  "breadcrumb": "Endre hovedsortiment",
  "navigation": {
    "backToSalesAgreement": "Tilbake til salgsavtale",
    "back": "Tilbake",
    "save": "Lagre endringer"
  },
  "section": {
    "title": "Hovedsortiment",
    "description": "Legg til eller fjern hovedsortiment(er) for salgsavtalen"
  },
  "detail": {
    "description": "Oversikt over avtalens hovedsortimenter",
    "editButton": "Endre hovedsortiment",
    "emptyTitle": "Ingen hovedsortiment",
    "emptyDescription": "Det er ingen hovedsortimenter knyttet til denne salgsavtalen."
  },
  "list": {
    "emptyTitle": "Ingen hovedsortiment valgt",
    "emptyDescription": "Salgsavtalen kan ikke lagres før ett eller flere hovedsortimenter er valgt.\nTrykk på \"Legg til hovedsortiment\" for å begynne."
  },
  "table": {
    "number": "Nr",
    "name": "Sortimentnavn"
  },
  "actions": {
    "add": "Legg til hovedsortiment",
    "remove": "Fjern",
    "menuAriaLabel": "Flere handlinger for hovedsortiment"
  },
  "addDialog": {
    "title": "Legg til hovedsortiment",
    "description": "Du kan legge til flere sortimenter samtidig.",
    "fieldLabel": "Velg sortimentstype",
    "searchPlaceholder": "Søk etter sortiment",
    "noResults": "Ingen sortimenter funnet",
    "cancel": "Avbryt",
    "confirm": "Legg til sortimenter",
    "loading": "Laster sortimenter",
    "errorDescription": "Noe gikk galt under henting av sortimenter. Prøv igjen.",
    "inactiveSelectedError": "Ett eller flere valgte sortimenter er deaktivert i Virkeshandel og kan ikke brukes.",
    "inactiveSuffix": " (deaktivert)"
  },
  "removeDialog": {
    "title": "Fjern hovedsortiment?",
    "description": "Er du sikker på at du vil fjerne {{identifier}} - {{assortmentName}}?",
    "cancel": "Avbryt",
    "confirm": "Fjern sortiment"
  },
  "toast": {
    "saveError": {
      "title": "Kunne ikke lagre hovedsortiment",
      "description": "Noe gikk galt under lagring av hovedsortiment. Prøv igjen."
    }
  },
  "error": {
    "title": "Kunne ikke laste hovedsortiment",
    "description": "Noe gikk galt under henting av salgsavtalen. Prøv igjen."
  }
}
